import { useState } from 'react';
import { Camera, Trash2 } from 'lucide-react';
import { Avatar, Button } from '@tcrd/ui';
import { errorMessage } from '../lib/api';
import { pickImage } from '../lib/media';
import { useToast } from './toast';

/** Foto de perfil con acciones de cambiar y eliminar. */
export function PhotoEditor({
  src,
  firstName,
  lastName,
  onUpload,
  onRemove,
  size = 96,
}: {
  src: string | null | undefined;
  firstName?: string;
  lastName?: string;
  onUpload: (blob: Blob) => Promise<unknown>;
  onRemove?: () => Promise<unknown>;
  size?: number;
}) {
  const [busy, setBusy] = useState<'upload' | 'remove' | null>(null);
  const toast = useToast();

  const change = async () => {
    try {
      const blob = await pickImage();
      if (!blob) return;
      setBusy('upload');
      await onUpload(blob);
      toast('Foto actualizada');
    } catch (e) {
      toast(errorMessage(e), 'danger');
    } finally {
      setBusy(null);
    }
  };

  return (
    <div className="flex items-center gap-4">
      <div className="relative">
        <Avatar src={src} firstName={firstName} lastName={lastName} size={size} />
        <button
          type="button"
          onClick={change}
          aria-label="Cambiar foto"
          className="tap absolute -bottom-1 -right-1 size-10 rounded-full bg-brand-red text-white flex items-center justify-center shadow-[var(--shadow-float)]"
        >
          <Camera className="size-5" aria-hidden />
        </button>
      </div>
      <div className="flex flex-col gap-2">
        <Button size="sm" variant="secondary" loading={busy === 'upload'} onClick={change}>
          {src ? 'Cambiar foto' : 'Agregar foto'}
        </Button>
        {src && onRemove && (
          <Button
            size="sm"
            variant="ghost"
            icon={<Trash2 className="size-4" />}
            loading={busy === 'remove'}
            onClick={async () => {
              setBusy('remove');
              try {
                await onRemove();
                toast('Foto eliminada');
              } catch (e) {
                toast(errorMessage(e), 'danger');
              } finally {
                setBusy(null);
              }
            }}
          >
            Eliminar
          </Button>
        )}
      </div>
    </div>
  );
}
